import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ProductSalesPaginationDTO, SalesPaginationDTO } from "../../dtos/batch";
import SalesHistoryService from "./salesHistoryService";

// Define initial state
const initialState = {
  salesHistoryDetails: [],
  salesHistoryId: "",
  isLoading: false,
  isSuccess: false,
  isError: false,
  message: <any>"",

  isSalesHistoryLoading: false,

  isSalesHistoryLoadingError: false,
};
export const getSalesHistoryData = createAsyncThunk(
  "salesHistory/getSalesHistoryData", // Action type prefix
  async (
    { pharmacy_id, dto }: { pharmacy_id: any; dto?: SalesPaginationDTO },
    thunkAPI
  ) => {
    try {
      const response = await SalesHistoryService.getSalesHistory(
        pharmacy_id,
        dto
      ); // Call the function
      return response.data;
    } catch (error: any) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const getProductSalesHistoryData = createAsyncThunk(
  "salesHistory/getProductSalesHistory", // Action type prefix
  async (
    { pharmacy_id, dto }: { pharmacy_id: any; dto?: ProductSalesPaginationDTO },
    thunkAPI
  ) => {
    try {
      const response = await SalesHistoryService.getProductSalesHistory(
        pharmacy_id,
        dto
      ); // Call the function
      return response.data;
    } catch (error: any) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
// export const editSupplier = createAsyncThunk(
//   "supplier/edit",
//   async (supplier: AddSupplierDTO, thunkAPI) => {
//     try {
//       return await SupplierService.editSupplier(supplier);
//     } catch (error: any) {
//       const message =
//         (error.response &&
//           error.response.data &&
//           error.response.data.message) ||
//         error.message ||
//         error.toString();
//       return thunkAPI.rejectWithValue(message);
//     }
//   }
// );
export const salesHistorySlice = createSlice({
  name: "salesHistorySlice",
  initialState,
  reducers: {
    reset: () => initialState,
    changeSalesHistoryId: (state, action) => {
      state.salesHistoryId = action.payload;
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(getSalesHistoryData.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getSalesHistoryData.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.salesHistoryDetails = action.payload;
        state.message = "";
      })
      .addCase(getSalesHistoryData.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      });
  },
});

// Export actions and reducer
export const { reset, changeSalesHistoryId } = salesHistorySlice.actions;
export default salesHistorySlice.reducer;
